import classNames from 'classnames';
import Avatar from 'components/base/Avatar';
import Badge from 'components/base/Badge';
import { Conversation } from 'data/chat';
import { useChatContext } from 'providers/ChatProvider';
import React, { useMemo } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MARKED_AS_READ } from 'reducers/ChatReducer';

import { useAppContext } from 'providers/AppProvider';
import { useSelector } from 'react-redux';
import { RootState } from 'store'; // Import the RootState type from your store
import { useDispatch } from 'react-redux';

// Small country flag from the CDN; uppercased 2-letter code as a fallback label.
const flagSrc = (country?: string) =>
  country ? `https://cdn.easychatdesk.com/flags/${country.toLowerCase()}.svg` : '';

const displayName = (name?: string) =>
  name && String(name).trim() ? name : 'Unnamed Customer';

const UserListitem = ({ customer }: { customer: any }) => {
  const { currentConversation, chatDispatch } = useChatContext();

  const {
    config: { isDark }
  } = useAppContext();

  const lastMessage = '';
  const unseenMessageCount = 0;

  const markedAsRead = () => {};

  const showLatestMessage = () => {
    if (customer.messages.length == 0) return 'There are no messages.';

    return customer.messages[customer.messages.length - 1].message;
  };

  return (
    <Nav.Item
      key={customer.cid}
      className={unseenMessageCount > 0 ? 'read' : 'unread'}
      style={{
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: isDark ? '#1d1d1d' : '#ddd'
      }}
    >
      <Nav.Link
        as={Link}
        to={`/apps/chat/${customer.customer_id}/conversation`}
        onClick={markedAsRead}
        className={classNames(
          'd-flex align-items-center justify-content-center p-2',
          {
            unread: unseenMessageCount > 0,
            active: currentConversation === customer.customer_id
          }
        )}
      >
        <div className="position-relative me-2 me-sm-0 me-xl-2">
          <Avatar
            src={customer.avatar}
            size="xl"
            className="d-block"
            imageClassName="border border-2 border-light-subtle"
          />
          {unseenMessageCount > 0 && (
            <span
              className="bg-primary rounded-circle top-0 end-0 position-absolute text-white d-flex flex-center fs-10 fw-semibold d-none d-sm-flex d-xl-none lh-1"
              style={{ height: '1rem', width: '1rem' }}
            >
              {unseenMessageCount}
            </span>
          )}
        </div>
        <div className="flex-1 d-sm-none d-xl-block">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="text-body fw-normal name text-nowrap d-flex align-items-center">
              {customer.country && (
                <img
                  src={flagSrc(customer.country)}
                  width={18}
                  className="me-2 rounded-1"
                  alt={customer.country_name || customer.country}
                  title={customer.country_name || customer.country.toUpperCase()}
                />
              )}
              {displayName(customer.name)}
            </h5>
            <p className="fs-10 text-body-tertiary text-opacity-85 mb-0 text-nowrap">
              {customer.time}
            </p>
          </div>
          <div className="d-flex justify-content-between">
            <p className="fs-9 mb-0 line-clamp-1 text-body-tertiary text-opacity-85 message">
              {showLatestMessage()}
            </p>
            {unseenMessageCount > 0 && (
              <Badge
                variant="phoenix"
                bg="primary"
                className="px-1 unread-badge ms-1"
              >
                {unseenMessageCount}
              </Badge>
            )}

            {customer?.active == true ? (
              <Badge bg={'success'}>active</Badge>
            ) : (
              <Badge bg={'secondary'}>inactive</Badge>
            )}
          </div>
        </div>
      </Nav.Link>
    </Nav.Item>
  );
};

const UserList = ({ conversations }: { conversations: Conversation[] }) => {
  const trafficInformation = useSelector(
    (state: RootState) => state.traffic.customers
  );

  // De-duplicate by customer_id so the same visitor never appears twice, even
  // if a reducer path added them more than once.
  const uniqueCustomers = Array.from(
    new Map(trafficInformation.map(c => [c.customer_id, c])).values()
  );

  return (
    <div className="scrollbar">
      <Nav className="chat-conversation-tab flex-column">


{uniqueCustomers
  .slice() // copy so you don't mutate Redux state
  .sort((a, b) => Number(b.active) - Number(a.active)) // active=true first
  .map(customer => (
    <UserListitem customer={customer} key={customer.customer_id} />
  ))}



      </Nav>
    </div>
  );
};

export default UserList;
